import {SoilSamplePlanningStore}                                                 from '../../stores/nutrients/soilsampleplanning.store';
import {
  SoilSamplePlanningReportStore
}                                                                                from '../../stores/nutrients/soilsampleplanning-report.store';
import {AfterContentInit, Component, EventEmitter, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {BehaviorSubject, combineLatest, Observable, Subscription}                from 'rxjs';
import {
  ApGridPagerType,
  ApStatsType,
  IBarLineAreaChartData,
  IBarLineAreaChartDataValue,
  IGridPagerData,
  IWizardChoiceData,
  MapViewCurrentMenu,
  MapViewMode
}                                                                                from '../../ap-interface';
import * as moment                                                               from 'moment';
import {saveAs}                                                                  from '@progress/kendo-file-saver';
import {debounceTime, delay, filter, map}                                        from 'rxjs/operators';
import {
  ApDynComponentComponent
}                                                                                from '../../ap-dyncomponent/ap-dyncomponent.component';
import {
  ApDynGridColumnConfigBase,
  ApDynGridColumnHideConfig
}                                                                                from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridPagerConfigBase
}                                                                                from '../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {
  ApDynGridPropertyColumnConfig,
  FilterType
}                                                                                from '../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  ApDynGridPagerConfig
}                                                                                from '../../ap-dyngrids/config/ap-dyn-grid-pager-config';
import {
  ApDynGridStatusColumnConfig
}                                                                                from '../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {ApGuidUtil, GetRoundNumericPipe}                                         from '../../ap-utils';
import {
  SettingsStore
}                                                                                from '../../stores/base-data/settings.store';
import {FieldStore}                                                              from '../../stores/farm/field.store';
import {
  LanguageStore
}                                                                                from '../../stores/translation/language.store';
import {
  MapViewStore
}                                                                                from '../../stores/layout/mapview.store';
import {LoginStore}                                                              from '../../stores/login/login.store';
import {
  CampaignYearStore
}                                                                                from '../../stores/login/campaignyear.store';
import {
  ApDateService
}                                                                                from '../../ap-core/services/ap-date-service';
import {Create, ObjectFactory}                                                   from 'ts-tooling';
import {
  ApNutrientPlanningComponent
}                                                                                from '../../entry-components/ap-nutrients-management-entry-components/ap-nutrient-planning.component';
import {FormStore}                                                               from '../../stores/layout/form.store';
import {
  ApSoilSampleService
}                                                                                from '../service/ap-soil-sample.service';
import {
  JobsStore
}                                                                                from '../../stores/administration/jobs.store';
import {
  IChartSet,
  StatisticStore
}                                                                                from '../../stores/statistic/statistic.store';
import {
  SoilSampleDateStore
}                                                                                from '../../stores/nutrients/soilsampledate.store';
import {
  ApDynGridGroupColumnConfig
}                                                                                from '../../ap-dyngrids/config/ap-dyn-grid-group-column-config';
import {
  CropRotationStore
}                                                                                from '../../stores/farm/crop.rotation.store';
import {
  ApTranslationService
}                                                                                from '../../ap-utils/service/ap-translation.service';
import {
  ApIcons
}                                                                                from '../../ap-interface/enums/layout/ap-icons';
import {
  ApUtilService
}                                                                                from '../../ap-utils/service/ap-util.service';
import {
  GetRoundNumericService
}                                                                                from '../../ap-utils/service/get-round-numeric.service';
import {
  ApRoleTypeService
}                                                                                from '../../services/common/ap-role-type.service';
import {
  IApFieldsWithSoilSamplePlanning,
  ISoilSamplingGridData,
  SoilSampleEdits,
  SoilSamplePlannedScan,
  SoilSamplePlanningOverviewActions,
  SoilSampleScanningStatus
}                                                                                from '../types/base-fertilization-soil-sampleplanning.types';
import {
  PlanningEntryComponentDataType
}                                                                                from '../../entry-components/ap-nutrients-management-entry-components/ap-nutrient-planning-configs/nutrient-planning-types';
import {
  StatisticService
}                                                                                from '../../services/data/statistic.service';
import {nameOf}                                                                  from '../../ap-core/utils/ap-name-of';
import {
  IGridStatus
}                                                                                from '../../ap-interface/interfaces/ap-grid-status.interface';
import {
  LandUseService
}                                                                                from '../../services/data/landuse.service';
import {
  LandUseStore
}                                                                                from '../../stores/base-data/landuse.store';
import {
  ApColumnState
}                                                                                from '../../ap-interface/enums/ap-column-state.enum';
import IField = Data.FieldManagement.IField;
import ISoilSamplePlanning = Data.IpsPlanning.ISoilSamplePlanning;
import IContentRow = Agriport.Excel.Factory.InputData.SoilSamplePlanningReport.IContentRow;
import IReportData = Agriport.Excel.Factory.InputData.SoilSamplePlanningReport.IReportData;
import ISoilSamplePlanningExportData = Data.IpsPlanning.ISoilSamplePlanningExportData;

/**
 * TODO EXCEL und PDF Export ermöglichen --> Jira Ticket angelegt https://jira.agricon.de/browse/APV49-826
 */

@Component({
  selector: 'ap-soilsampleplanning-overview',
  template: `
    <ap-dyncomponent [caption]="'Base__OrderPlanning'"
                     [canCreate]="false"
                     [canSearch]="true"
                     [headerIcon]="'ap-icon-base-fertilization'"
                     [filterTooltip]="'filterTooltip'"
                     [columns]="columns$ | async"
                     [items]="items$ | async"
                     [loading$]="loading$"
                     [pager]="pager"
                     [groupable]="true"
                     [pdfExportTitle]="'Base__OrderPlanning'"
                     [exportFileName]="exportFileName"
                     [selectable]="{checkboxOnly: false, mode: 'multiple'}"
                     (create)="onCreate()"
    ></ap-dyncomponent>`
})

export class ApSoilSamplePlanningOverviewComponent implements OnInit, AfterContentInit, OnDestroy {
  @ViewChild(ApDynComponentComponent, {static: true}) dynComponent: ApDynComponentComponent;
  public columns$: Observable<ApDynGridColumnConfigBase[]>;
  public items$: Observable<ISoilSamplingGridData[]>;
  public loading$: Observable<boolean>;
  public pager: ApDynGridPagerConfigBase;
  public exportFileName = '';

  private _areaTotal = 0;
  private _listMassEditing = [];
  private _subscriptions: Array<Subscription> = [];
  private _previousMapViewMenu: MapViewCurrentMenu;
  private _nextYear = new EventEmitter<void>();
  private _applyClicked = new EventEmitter<any>();
  private _previousYear = new EventEmitter<void>();
  private _year$ = new BehaviorSubject<number>(undefined);
  private _cropRotationLimits$ = new BehaviorSubject<{ min: number, max: number }>({min: 0, max: 0});

  constructor(private soilSamplePlanningStore: SoilSamplePlanningStore,
              private formStore: FormStore,
              private loginStore: LoginStore,
              private campaignYearStore: CampaignYearStore,
              private mapViewStore: MapViewStore,
              private translationService: ApTranslationService,
              private fieldStore: FieldStore,
              private languageStore: LanguageStore,
              private roundNumericPipe: GetRoundNumericPipe,
              private cropRotationStore: CropRotationStore,
              private settingsStore: SettingsStore,
              private soilSamplePlanningReportStore: SoilSamplePlanningReportStore,
              private dateService: ApDateService,
              private soilSampleService: ApSoilSampleService,
              private soilSampleDateStore: SoilSampleDateStore,
              private jobsStore: JobsStore,
              private landUseStore: LandUseStore,
              private statisticStore: StatisticStore,
              private landUseService: LandUseService,
              private statisticService: StatisticService,
              private roundNumericService: GetRoundNumericService) {
  }

  public ngOnInit(): void {
    const currentCampaignYear = this.campaignYearStore?.getSelectedCampaignYear()?.Year ?? 0;
    this._cropRotationLimits$.next({min: currentCampaignYear, max: currentCampaignYear});
    this._previousMapViewMenu = this.mapViewStore.getMapViewCurrentMenu();
    this.soilSamplePlanningStore.loadSoilSamplePlanning();
    this.soilSamplePlanningStore.loadSoilSampleScanning();
    this.mapViewStore.goIntoStatisticMenu();
    this.loading$ = combineLatest([
      this.fieldStore.Loading$,
      this.landUseStore.Loading$,
      this.languageStore.Loading$,
      this.settingsStore.Loading$,
      this.campaignYearStore.Loading$,
      this.cropRotationStore.Loading$,
      this.soilSampleDateStore.Loading$,
      this.soilSamplePlanningStore.Listen(s => s.loading),
    ]).pipe(
      map((loadings) => loadings.some(loading => loading))
    );
    this.gridBuilder();
    this.generateItems();
  }

  public ngAfterContentInit(): void {
    this._subscriptions.push(this._applyClicked.subscribe((e) => this.onApplyClicked(e)));
    this._subscriptions.push(
      combineLatest([
        this.cropRotationStore.Listen(s => s.history).pipe(
          map((history) => Object.values(history)),
          filter((crops) => crops.length !== 0),
          map((crops) => crops.map((crop) => Object.keys(crop).filter((key) => crop[key] !== null).map((key) => +key))),
          map((years) => years.reduce((a, b) => a.concat(b)))),
        this.campaignYearStore.Listen(s => s.selectedYear)
      ]).pipe(
        map(([dates, campaignYear]) => ({
          min: Math.min(...dates, campaignYear.Year),
          max: Math.max(...dates, campaignYear.Year)
        }))
      ).subscribe(l => this._cropRotationLimits$.next(l))
    );
    this._subscriptions.push(this.loginStore.SelectedFarm$.subscribe(() => {
      this.soilSamplePlanningStore.loadSoilSamplePlanning();
      this.soilSamplePlanningStore.loadSoilSampleScanning();
    }));
    this._subscriptions.push(this.campaignYearStore.Listen(s => s.selectedYear).subscribe((campaignYear) => {
      if (campaignYear) {
        this._year$.next(campaignYear.Year - 1);
      }
    }));
    this._subscriptions.push(this._previousYear.subscribe(() => {
      this._year$.next(this._year$.value - 1);
    }));
    this._subscriptions.push(this._nextYear.subscribe(() => {
      this._year$.next(this._year$.value + 1);
    }));
    this._subscriptions.push(this.soilSamplePlanningStore.Listen(s => s.shapeExport).subscribe(data => {
      if (data) {
        this.downloadShapeExportZipped(data);
      }
    }));
    this._subscriptions.push(this.items$.pipe(
      debounceTime(500),
      delay(1)).subscribe(_ => {
      setTimeout(() => this.generateStats(), 0);
    }));
    this.dynComponent.SelectedItems$.subscribe((data: ISoilSamplingGridData[]) => {
      if (this.mapViewStore.getMapViewMode() !== MapViewMode.HIDE
        && this.mapViewStore.getMapViewCurrentMenu() === MapViewCurrentMenu.MAP) {
        this.fieldStore.changeSelectedField(data.map(x => x.Id.toString()));
      }
      this.generateStats();
    });
    this.fillWizardChoiceData();
    this.generateStats();
  }

  public ngOnDestroy(): void {
    // go back to mapViewMode when user leaves Probenahmeplanung
    if (this._previousMapViewMenu === MapViewCurrentMenu.MAP) {
      this.mapViewStore.goIntoMapMenu();
    }
    this.statisticStore.removeStatisticData();
    this._subscriptions.forEach(d => d?.unsubscribe());
  }

  public onCreate(): void {
    this.formStore.openForm({
      component: ApNutrientPlanningComponent,
      data: {
        Summary: null,
        Type: PlanningEntryComponentDataType.Create
      }
    });
  }

  private generateItems(): void {
    this.items$ = combineLatest([
      this.campaignYearStore.Listen(s => s.selectedYear),
      this.cropRotationStore.Listen(s => s.history),
      this.fieldStore.Listen(s => s.data),
      this.soilSampleDateStore.Listen(s => s.dates),
      this.soilSamplePlanningStore.Listen(s => s.data),
      this.soilSamplePlanningStore.Listen(s => s.scanningData),
      this.landUseStore.LandUse$
    ]).pipe(
      filter(([campaignYear, cropRotation, fields, soilSampleDates, plannings, _, _1]) =>
        fields?.length !== 0 && !!plannings && campaignYear?.Year > 0 && !!soilSampleDates && !!cropRotation),
      map(([, cropRotation, fields, soilSampleDates, plannings, scans, landUses]) => {
        const fieldsJoinedWithSoilSamplePlanning: IApFieldsWithSoilSamplePlanning[] = [];
        this._areaTotal = 0;
        for (const field of fields) {
          fieldsJoinedWithSoilSamplePlanning.push({
            Id: field.Id,
            Field: field,
            // find existing SoilSamplePlanning or create a fake/empty object to be able to apply new soil sample dates
            SoilSamplePlanning: plannings.find(x => x.FieldId === field.Id) ?? {
              Description: undefined,
              FieldId: field.Id,
              Id: undefined,
              LastSamplingdate: undefined,
              OrganicApplication: undefined,
              PlannedSamplingdate: undefined,
              UserId: undefined
            } as ISoilSamplePlanning,
            SoilSampleScanning: scans.find(x => x.Id === field.Id),
          });
        }
        return fieldsJoinedWithSoilSamplePlanning.map(planning => {
          const geom = this.fieldStore.getCurrentFieldGeom(planning.Field);
          const area = Create(geom?.AdminArea, 0) / 10000;
          if (area > 0) {
            this._areaTotal = this._areaTotal + area;
          }
          const planningIdAsString = planning.Id.toString();
          const organic = planning?.SoilSamplePlanning?.OrganicApplication ? 'Global__Yes' : '';
          const lastSamplingDate = soilSampleDates[planningIdAsString];
          const cropRotationData = cropRotation[planningIdAsString];
          const lastSamplingDateMidnight = !!lastSamplingDate?.Date
            ? this.dateService.getDateMidnight(this.dateService.toFarmDateFromUtc(lastSamplingDate.Date).toDate())
            : undefined;
          const nextSamplingDateNoon = !!planning?.SoilSamplePlanning?.PlannedSamplingdate
            ? this.dateService.getDateNoonToFarmTime(
              this.dateService.toFarmDateFromUtc(planning.SoilSamplePlanning.PlannedSamplingdate).toDate()
            )
            : undefined;
          let sampleAmount: number | undefined = undefined;
          if (planning.Field.GridSize != null) {
            sampleAmount = this.roundNumericService.roundAsNumber(area / planning.Field.GridSize, 0);
            if (sampleAmount < 1) {
              sampleAmount = 1;
            }
          }
          return {
            Id: planning.Id,
            FieldName: planning.Field.FieldName,
            FieldNumber: planning.Field.FieldNumber,
            FieldSumNumber: planning.Field.FieldSubnumber,
            NrSNr: this.fieldStore.getFieldNumberAndSubNumber(planning.Field),
            LandUse: this.landUseService.getLandUseAsStatus(lastSamplingDate?.LandUse, landUses,
              {state: 0, class: 'ap-status-grey', description: undefined}),
            SamplingStatus: this.getSamplingStatus(lastSamplingDateMidnight),
            ScanningData: planning.SoilSampleScanning,
            ScanningDataValue: planning.SoilSampleScanning ? (planning.SoilSampleScanning.ScanCov > 80 ? SoilSampleScanningStatus.MoreThan80 : SoilSampleScanningStatus.LessThan80) : SoilSampleScanningStatus.NotAvailable,
            ScanningDataClass: planning.SoilSampleScanning?.ScanCov <= 80 ? ' ap-grey-checkbox' : '',
            ScanningDataTooltip: this.getScanningDataTooltip(planning),
            Geom: geom,
            Area: area,
            LastSamplingDate: lastSamplingDateMidnight,
            NextSamplingDate: nextSamplingDateNoon,
            OrganicApplication: this.translationService.translate(organic),
            Note: planning?.SoilSamplePlanning?.Description,
            Crop: cropRotationData,
            GridSize: planning.Field.GridSize,
            SampleAmount: sampleAmount,
            PlannedScan: planning.SoilSamplePlanning.PlannedScan ?? false,
            SourceItem: planning
          } as ISoilSamplingGridData;
        });
      })
    );
  }

  private getScanningDataTooltip(planning: IApFieldsWithSoilSamplePlanning): string {
    if (!planning.SoilSampleScanning) {
      return '';
    }
    const currentFormat = this.languageStore.CurrentDateFormat;
    const minDateDisplay = planning.SoilSampleScanning.MinScanDate ? this.dateService.dateToMoment(planning.SoilSampleScanning.MinScanDate).format(currentFormat) : '';
    const maxDateDisplay = planning.SoilSampleScanning.MaxScanDate ? this.dateService.dateToMoment(planning.SoilSampleScanning.MaxScanDate).format(currentFormat) : '';
    return `${this.translationService.translate('Global__Coverage')} ${planning.SoilSampleScanning.ScanCov} % <br/>(${minDateDisplay}${(minDateDisplay !== '' && maxDateDisplay !== '') ? ' - ' : ''}${maxDateDisplay})`;
  }

  private gridBuilder(): void {
    this.columns$ = combineLatest([
      this._cropRotationLimits$.asObservable(),
      this.settingsStore.FirstSetting$
    ]).pipe(
      filter(([limits]) => Number.isFinite(limits?.min) && Number.isFinite(limits?.max)),
      map(([limits, settings]) => [
        new ApDynGridPropertyColumnConfig({
          title: 'Global__NumberAbbr',
          field: nameOf<ISoilSamplingGridData>('NrSNr'),
          filterable: true,
          width: 75,
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__FieldName',
          field: nameOf<ISoilSamplingGridData>('FieldName'),
          filterable: true,
          headerFilterable: true,
          sortIndex: 0,
          sortDesc: false,
          width: 180,
          cssClass: 'left',
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__Area_Unit',
          field: nameOf<ISoilSamplingGridData>('Area'),
          headerFilterable: true,
          width: 60,
          cssClass: 'right',
          filterType: FilterType.NUMBER,
          tooltip: (dataItem) => (dataItem as ISoilSamplingGridData).Area.toString(),
          pipes: [{
            pipe: this.roundNumericPipe,
            args: [settings.DigitsAfterDecimalPoint]
          }]
        }),
        new ApDynGridGroupColumnConfig({
          style: 'text-align:center',
          headerButtons: {
            nextClicked: this._nextYear,
            nextDisabled: this._year$.pipe(map((y) => y >= limits.max)),
            previousClicked: this._previousYear,
            previousDisabled: this._year$.pipe(map((y) => y <= limits.min)),
          },
          title: 'Global__Crop',
          groupColumns: this.getCropRotationGridConfigs(limits),
          width: 100,
          hide: new ApDynGridColumnHideConfig({
            widthHidePriority: 1
          })
        }),
        new ApDynGridGroupColumnConfig({
          title: 'Global__SampleDate_Short',
          style: 'text-align:center',
          groupColumns: [
            new ApDynGridStatusColumnConfig({
              field: `${nameOf<ISoilSamplingGridData>('SamplingStatus')}.${nameOf<IGridStatus>('state')}`,
              class: `${nameOf<ISoilSamplingGridData>('SamplingStatus')}.${nameOf<IGridStatus>('class')}`,
              description: `${nameOf<ISoilSamplingGridData>('SamplingStatus')}.${nameOf<IGridStatus>('description')}`,
              pending: this.jobsStore.BlockedFieldIdsBuWsv$,
              pendingTooltip: this.jobsStore.BlockedFieldIdsBuWsvTooltip$
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Scan',
              field: nameOf<ISoilSamplingGridData>('ScanningDataValue'),
              checkbox: true,
              hide: false,
              width: 30,
              filterable: true,
              filterClassField: nameOf<ISoilSamplingGridData>('ScanningDataClass'),
              dynCssClass: dataItem => dataItem.ScanningDataClass,
              tooltip: dataItem => dataItem.ScanningDataTooltip
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Date',
              field: nameOf<ISoilSamplingGridData>('LastSamplingDate'),
              cssClass: 'right',
              filterable: true,
              headerFilterable: true,
              format: 'YYYY',
              width: 60
            })
          ]
        }),
        new ApDynGridGroupColumnConfig({
          title: 'Base__OrderPlanning',
          style: 'text-align:center',
          groupColumns: [
            new ApDynGridStatusColumnConfig({
              field: `${nameOf<ISoilSamplingGridData>('LandUse')}.${nameOf<IGridStatus>('state')}`,
              class: `${nameOf<ISoilSamplingGridData>('LandUse')}.${nameOf<IGridStatus>('class')}`,
              description: `${nameOf<ISoilSamplingGridData>('LandUse')}.${nameOf<IGridStatus>('description')}`,
              title: 'LandUse',
              groupTitle: 'LandUse',
              showHeaderTitle: false,
              width: 30
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Grid_Size',
              field: nameOf<ISoilSamplingGridData>('GridSize'),
              cssClass: 'center',
              hide: true,
              headerFilterable: true,
              filterable: true,
              filterType: FilterType.NUMBER,
              tooltip: (dataItem) => this.getGridSizeTooltip(dataItem),
              width: 30
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Scan_Planned',
              field: nameOf<ISoilSamplingGridData>('PlannedScan'),
              checkbox: true,
              hide: false,
              width: 30,
              filterable: true,
              filterClassField: nameOf<ISoilSamplingGridData>('PlannedScan')
            }),
            new ApDynGridPropertyColumnConfig({
              cssClass: 'right',
              title: 'Nutrients__Scheduled',
              field: nameOf<ISoilSamplingGridData>('NextSamplingDate'),
              format: 'MM.YYYY',
              filterable: true,
              headerFilterable: true,
              width: 60
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Organic_Planned_Short',
              field: nameOf<ISoilSamplingGridData>('OrganicApplication'),
              filterable: true,
              headerFilterable: true,
              width: 30,
              hide: true
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Note',
              field: nameOf<ISoilSamplingGridData>('Note'),
              filterable: true,
              headerFilterable: true,
              width: 180,
              hide: true
            })
          ]
        }),
      ])
    );
    this.pager = new ApDynGridPagerConfig({
      listMassEditing: ApRoleTypeService.hasAgriconRole(this.loginStore.User) ? this._listMassEditing : null,
      apply: this._applyClicked,
      hasPermission: true,
      iconButtons: [
        {
          icon: ApIcons.PDF,
          callback: ApUtilService.createEventEmitter(this.exportAsPdf.bind(this), this._subscriptions),
          tooltip: 'Global__Save_PDF'
        },
        {
          icon: ApIcons.XLS,
          callback: ApUtilService.createEventEmitter(this.exportAsXls.bind(this), this._subscriptions),
          tooltip: 'Global__Save_EXCEL'
        },
        {
          icon: ApIcons.Shape,
          callback: ApUtilService.createEventEmitter(this.exportShape.bind(this), this._subscriptions),
          tooltip: 'Nutrients_Ips_Pages__ShpExport'
        },
      ]
    });
  }

  private getGridSizeTooltip(dataItem: ISoilSamplingGridData | undefined = undefined): string {
    if (!dataItem.SampleAmount) {
      return '';
    }

    return `${this.roundNumericService.round(dataItem.SampleAmount, 0)} ${this.translationService.translate('Nutrients_Pages__Samples')}`;
  }

  private getSamplingStatus(lastSamplingDateMidnight: Date | undefined): IGridStatus {
    const status = this.soilSampleService.getStatus(lastSamplingDateMidnight);
    return {
      state: status,
      class: status === ApColumnState.Green
        ? 'ap-status-green'
        : status === ApColumnState.Yellow ? 'ap-status-yellow' : 'ap-status-red',
      description: status === ApColumnState.Green
        ? 'Nutrients_Ips_Pages__StatusGreen'
        : status === ApColumnState.Yellow ? 'Nutrients_Ips_Pages__StatusYellow' : 'Nutrients_Ips_Pages__StatusRed'
    };
  }

  private getCropRotationGridConfigs(limits: { min: number, max: number }): ApDynGridColumnConfigBase[] {
    const columns = [];
    for (let iYear = limits.min; iYear <= limits.max + 3; ++iYear) {
      columns.push(new ApDynGridPropertyColumnConfig({
        title: `${iYear}`,
        field: `Crop.${iYear}.MainCropName`,
        filterable: true,
        headerFilterable: iYear === this.campaignYearStore.getSelectedCampaignYear().Year,
        width: 100,
        pdfExport: iYear === this.campaignYearStore.getSelectedCampaignYear().Year || iYear === this.campaignYearStore.getSelectedCampaignYear().Year - 1 || iYear === this.campaignYearStore.getSelectedCampaignYear().Year + 1,
        hide: new ApDynGridColumnHideConfig({
          mapHide: false,
          selfHide: combineLatest([this._year$, this.mapViewStore.Listen(s => s.mode)]).pipe(
            map(([year, mode]) => {
              if (mode !== MapViewMode.HIDE) {
                // show middle year-column when a map is visible
                return iYear !== (year + 1);
              } else {
                // show all 3 croprotation years
                return !(iYear >= year && iYear < year + 3);
              }
            }),
          ),
        }),
        tooltip: ((dataItem) => {
          const yesNo = (b: any) => this.translationService.translate(b ? 'LabelYes' : 'LabelNo');
          const unit = this.translationService.translate('Global__UnitDtPerHa');
          if (!dataItem || !dataItem['Crop'] || !dataItem['Crop'][iYear]) {
            return '';
          }
          const c = dataItem['Crop'][iYear].MainCropName;
          let s = '-';
          let sYieldUnit = '-';
          if (dataItem['Crop'][iYear].SecondCrop !== 0) {
            s = dataItem['Crop'][iYear].SecondCropName;
            sYieldUnit = dataItem['Crop'][iYear].SecondCropYield + ' ' + unit;
          }
          const mainCrop = `${this.translationService.translate('Nutrients_Pages_Popups__MainCrop')}: ${c}`;
          const targetMain = `${this.translationService.translate('Global__Target')}: ${dataItem['Crop'][iYear].MainCropYield} ${unit}`;
          const straw = `${this.translationService.translate('Nutrients_Pages__StrawRemoved')}: ${yesNo(dataItem['Crop'][iYear].MainCropStraw)}`;
          const interTillage = `${this.translationService.translate('Nutrients_Pages_Popups__Intertillage')}: ${s}`;
          const targetInter = `${this.translationService.translate('Global__Target')}: ${sYieldUnit}`;
          const br = '<br>';
          return `${mainCrop}${br}${targetMain}${br}${straw}${br}${interTillage}${br}${targetInter}`;
        })
      }));
    }
    return columns;
  }

  /**
   * Fill mass edit wizzard
   */
  private fillWizardChoiceData(): void {
    const currentDate = this.dateService.getFarmDate();
    this._listMassEditing.push(
      {
        id: SoilSampleEdits.DeleteValues,
        name: this.translationService.translate('Nutrients_Ips_Pages__DeleteValues'),
        type: ApGridPagerType.None,
        values: null
      } as IWizardChoiceData,
      {
        id: SoilSampleEdits.NextSampleDelete,
        name: this.translationService.translate('Nutrients_Ips_Pages__NextSample_delete'),
        type: ApGridPagerType.None,
        values: null
      } as IWizardChoiceData,
      {
        id: SoilSampleEdits.NextSample,
        name: this.translationService.translate('Nutrients_Ips_Pages__NextSample'),
        type: ApGridPagerType.CalenderMonthly,
        min: this.dateService.generateDate(1, currentDate.getMonth()).getTime(),
        max: this.dateService.generateDate(1, currentDate.getMonth(), currentDate.getFullYear() + 10).getTime(),
        values: null
      } as IWizardChoiceData,
      {
        id: SoilSampleEdits.OrgApplication,
        name: this.translationService.translate('Nutrients_Ips_Pages__OrganicSample'),
        type: ApGridPagerType.DropDown,
        values: [
          {
            id: SoilSamplePlanningOverviewActions.YES,
            label: this.translationService.translate('Global__Yes'),
          },
          {
            id: SoilSamplePlanningOverviewActions.NO,
            label: this.translationService.translate('Global__No'),
          }
        ]
      } as IWizardChoiceData,
      {
        id: SoilSampleEdits.Description,
        name: this.translationService.translate('Nutrients_Ips_Pages__Note'),
        type: ApGridPagerType.Text,
        values: null
      } as IWizardChoiceData,
      {
        id: SoilSampleEdits.GridSize,
        name: this.translationService.translate('Grid_Size'),
        type: ApGridPagerType.Numeric,
        values: null,
        min: 1,
        max: 10
      } as IWizardChoiceData,
      {
        id: SoilSampleEdits.PlannedScan,
        name: this.translationService.translate('Scan_Planned'),
        type: ApGridPagerType.DropDown,
        values: [
          {
            id: SoilSamplePlannedScan.Yes,
            label: this.translationService.translate('Global__Yes'),
          },
          {
            id: SoilSamplePlannedScan.No,
            label: this.translationService.translate('Global__No'),
          }
        ]
      } as IWizardChoiceData
    );
  }

  /**
   * generates the filename for Excel, PDF, and shape export.
   */
  public getExportFilename(): string {
    const customerExpr = this.loginStore.SelectedFarm?.CustomerNumber;
    const dateExpr = this.dateService.toFarmDate(new Date()).format('YYMMDD');
    return `${dateExpr}_${this.translationService.translate('Base__OrderPlanning')}_${customerExpr}`;
  }

  private onApplyClicked($event: IGridPagerData): void {
    const modifiedPlannings: ISoilSamplePlanning[] = [];
    const fieldsToSave = [];
    const foundItems = (this.dynComponent.getSelectedItems() as ISoilSamplingGridData[]).map(d => {
      return d.SourceItem;
    });
    if (!foundItems || foundItems.length === 0) {
      return;
    }
    for (const foundItem of foundItems) {
      const item = ObjectFactory.Copy(foundItem);
      if (!item?.SoilSamplePlanning || !item?.Field) {
        continue;
      }
      (item.SoilSamplePlanning as ISoilSamplePlanning).FieldId = (item.Field as IField).Id;
      switch ($event?.object?.id) {
        case SoilSampleEdits.DeleteValues: {
          (item.SoilSamplePlanning as ISoilSamplePlanning).Description = null;
          (item.SoilSamplePlanning as ISoilSamplePlanning).PlannedSamplingdate = null;
          (item.SoilSamplePlanning as ISoilSamplePlanning).OrganicApplication = null;
          break;
        }
        case SoilSampleEdits.NextSample: {
          // convert date from kendo (defaultz browser timezone) to farm timezone!
          (item.SoilSamplePlanning as ISoilSamplePlanning).PlannedSamplingdate =
            this.dateService.getDateNoonToFarmTime($event.value as Date, 1);
          (item.SoilSamplePlanning as ISoilSamplePlanning).UserId = this.loginStore.UserId;
          break;
        }
        case SoilSampleEdits.NextSampleDelete: {
          (item.SoilSamplePlanning as ISoilSamplePlanning).PlannedSamplingdate = undefined;
          (item.SoilSamplePlanning as ISoilSamplePlanning).UserId = this.loginStore.UserId;
          break;
        }
        case SoilSampleEdits.OrgApplication: {
          (item.SoilSamplePlanning as ISoilSamplePlanning).OrganicApplication =
            ($event.value.id === SoilSamplePlanningOverviewActions.YES);
          break;
        }
        case SoilSampleEdits.Description: {
          (item.SoilSamplePlanning as ISoilSamplePlanning).Description = ($event.value as any);
          break;
        }
        case SoilSampleEdits.GridSize: {
          if (Number.isFinite($event.value as number)) {
            item.Field.GridSize = +$event.value;
            fieldsToSave.push(item.Field);
          }
          break;
        }
        case SoilSampleEdits.PlannedScan: {
          item.SoilSamplePlanning.PlannedScan = $event.value.id === SoilSamplePlannedScan.Yes;
          break;
        }
        default:
          return;
      }

      // In case no user has been assigned to that particular soilSamplePlanning
      if ((item.SoilSamplePlanning as ISoilSamplePlanning).UserId == null) {
        (item.SoilSamplePlanning as ISoilSamplePlanning).UserId = this.loginStore.UserId;
      }

      // Generate GUID for new soilSamplePlanning
      if ((item.SoilSamplePlanning as ISoilSamplePlanning).Id == null) {
        (item.SoilSamplePlanning as ISoilSamplePlanning).Id = ApGuidUtil.generateNewGuid();
      }
      modifiedPlannings.push((item.SoilSamplePlanning as ISoilSamplePlanning));
    }

    if (fieldsToSave.length > 0) {
      this.fieldStore.editFieldsGridSize(fieldsToSave);
    } else {
      this.soilSamplePlanningStore.saveSoilSamplePlannings(modifiedPlannings);
    }
  }

  /**
   * When shape-export finished on backend, this method is triggered
   * to download the zip archive
   */
  private downloadShapeExportZipped(zipContent: ArrayBuffer): void {
    saveAs(new Blob([new Uint8Array(zipContent)], {type: 'application/zip'}),
      this.getExportFilename() + '.zip');
  }

  /**
   * exports selected fields/plannings as shape
   */
  private exportShape(): void {
    const selectedGridItems = this.dynComponent.getSelectedItems() as ISoilSamplingGridData[];
    if (!selectedGridItems || selectedGridItems.length === 0) {
      return;
    }
    const exportItems: ISoilSamplePlanningExportData[] = selectedGridItems.map(d => {
      const campaignYear = this.campaignYearStore.SelectedCampaignYear.Year;
      return {
        FieldId: d.SourceItem.Field?.Id,
        LastSampleDate: d.LastSamplingDate,
        CropTypeNameMinus1: d?.Crop?.hasOwnProperty(campaignYear - 1) ? d.Crop[campaignYear - 1]?.MainCropName : '',
        CropTypeName: d?.Crop?.hasOwnProperty(campaignYear) ? d.Crop[campaignYear]?.MainCropName : '',
        CropTypeNamePlus1: d?.Crop?.hasOwnProperty(campaignYear + 1) ? d.Crop[campaignYear + 1]?.MainCropName : '',
        CropTypeNamePlus2: d?.Crop?.hasOwnProperty(campaignYear + 2) ? d.Crop[campaignYear + 2]?.MainCropName : '',
        GridSize: d.GridSize,
        SampleAmount: d.SampleAmount,
        PlannedScan: d.PlannedScan
      };
    });
    this.soilSamplePlanningStore.exportShape(
      exportItems,
      this.campaignYearStore.getSelectedCampaignYear().DefaultStart,
      this.getExportFilename(),
      this.languageStore?.SelectedLanguage?.Key);
  }

  private exportAsPdf(): void {
    this.exportFileName = this.getExportFilename();
    this.dynComponent.dynGrid.exportAsPdf();
  }

  private exportAsXls(): void {
    const contentRows: IContentRow[] = [];
    const rows = this.dynComponent.getSelectedItems() as ISoilSamplingGridData[];
    rows.forEach((row: ISoilSamplingGridData) => {
      if (!!row) {
        const campaignYear = this.campaignYearStore.SelectedCampaignYear.Year;
        contentRows.push({
          LandUse: this.translationService.translate(row.LandUse.description),
          FieldNumber: row.FieldNumber,
          FieldSubNumber: row.FieldSumNumber,
          FieldName: row.FieldName,
          FieldArea: this.roundNumericService.roundAsNumber(row.Area, this.settingsStore.FirstSetting.DigitsAfterDecimalPoint),
          CropTypeMinus1: row?.Crop?.hasOwnProperty(campaignYear - 1) ? row?.Crop[campaignYear - 1]?.MainCropName : '',
          CropType: row?.Crop?.hasOwnProperty(campaignYear) ? row.Crop[campaignYear]?.MainCropName : '',
          CropTypePlus1: row?.Crop?.hasOwnProperty(campaignYear + 1) ? row.Crop[campaignYear + 1]?.MainCropName : '',
          CropTypePlus2: row?.Crop?.hasOwnProperty(campaignYear + 2) ? row.Crop[campaignYear + 2]?.MainCropName : '',
          LastSampleDate: row.LastSamplingDate ?
            this.dateService.dateToMoment(row.LastSamplingDate).format(this.languageStore.CurrentDateFormat)
            : '',
          NextSampleDate: row.NextSamplingDate ?
            this.dateService.dateToMoment(row.NextSamplingDate).format(this.languageStore.CurrentDateFormat)
            : '',
          OrganicApplication: row.OrganicApplication,
          Description: row.Note,
          GridSize: row.GridSize,
          SampleAmount: row.SampleAmount,
          PlannedScan: row.PlannedScan
        });
      }
    });
    const columns = this.getReportColumnNames();
    const reportData: IReportData = {
      Content: {
        HeaderLabels: [
          columns.get(nameOf<IContentRow>('LandUse')),
          columns.get(nameOf<IContentRow>('FieldNumber')),
          columns.get(nameOf<IContentRow>('FieldSubNumber')),
          columns.get(nameOf<IContentRow>('FieldName')),
          columns.get(nameOf<IContentRow>('FieldArea')),
          columns.get(nameOf<IContentRow>('CropTypeMinus1')),
          columns.get(nameOf<IContentRow>('CropType')),
          columns.get(nameOf<IContentRow>('CropTypePlus1')),
          columns.get(nameOf<IContentRow>('CropTypePlus2')),
          columns.get(nameOf<IContentRow>('LastSampleDate')),
          columns.get(nameOf<IContentRow>('GridSize')),
          columns.get(nameOf<IContentRow>('SampleAmount')),
          columns.get(nameOf<IContentRow>('PlannedScan')),
          columns.get(nameOf<IContentRow>('NextSampleDate')),
          columns.get(nameOf<IContentRow>('OrganicApplication')),
          columns.get(nameOf<IContentRow>('Description')),
        ],
        Rows: contentRows
      },
      Header: {
        LandUse: columns.get(nameOf<IContentRow>('LandUse')),
        FieldNumber: columns.get(nameOf<IContentRow>('FieldNumber')),
        FieldSubNumber: columns.get(nameOf<IContentRow>('FieldSubNumber')),
        FieldName: columns.get(nameOf<IContentRow>('FieldName')),
        FieldArea: columns.get(nameOf<IContentRow>('FieldArea')),
        CropTypeMinus1: columns.get(nameOf<IContentRow>('CropTypeMinus1')),
        CropType: columns.get(nameOf<IContentRow>('CropType')),
        CropTypePlus1: columns.get(nameOf<IContentRow>('CropTypePlus1')),
        CropTypePlus2: columns.get(nameOf<IContentRow>('CropTypePlus2')),
        LastSampleDate: columns.get(nameOf<IContentRow>('LastSampleDate')),
        NextSampleDate: columns.get(nameOf<IContentRow>('NextSampleDate')),
        OrganicApplication: columns.get(nameOf<IContentRow>('OrganicApplication')),
        Description: columns.get(nameOf<IContentRow>('Description')),
        GridSize: columns.get(nameOf<IContentRow>('GridSize')),
        SampleAmount: columns.get(nameOf<IContentRow>('SampleAmount')),
        PlannedScan: columns.get(nameOf<IContentRow>('PlannedScan')),
      }
    };
    const bookName = this.getExportFilename();
    this.soilSamplePlanningReportStore.downloadSoilSamplePlanningReport(bookName, `${bookName}.xlsx`, reportData);
  }

  private getReportColumnNames(): Map<string, string> {
    const columnNames = new Map<string, string>();
    const selectedCampaignYear = this.campaignYearStore.SelectedCampaignYear.Year;
    columnNames.set(nameOf<IContentRow>('LandUse'), this.translationService.translate('LandUse'));
    columnNames.set(nameOf<IContentRow>('FieldNumber'), this.translationService.translate('Docu_Ini__Number'));
    columnNames.set(nameOf<IContentRow>('FieldSubNumber'), this.translationService.translate('Docu_Ini_Subnumber'));
    columnNames.set(nameOf<IContentRow>('FieldName'), this.translationService.translate('Global__FieldName'));
    columnNames.set(nameOf<IContentRow>('FieldArea'), this.translationService.translate('Global__Area_Unit'));
    columnNames.set(nameOf<IContentRow>('CropTypeMinus1'), this.translationService.translate('Global__CropType') + ` (${selectedCampaignYear - 1})`);
    columnNames.set(nameOf<IContentRow>('CropType'), this.translationService.translate('Global__CropType') + ` (${selectedCampaignYear})`);
    columnNames.set(nameOf<IContentRow>('CropTypePlus1'), this.translationService.translate('Global__CropType') + ` (${selectedCampaignYear + 1})`);
    columnNames.set(nameOf<IContentRow>('CropTypePlus2'), this.translationService.translate('Global__CropType') + ` (${selectedCampaignYear + 2})`);
    columnNames.set(nameOf<IContentRow>('LastSampleDate'), this.translationService.translate('Nutrients_Ips_Pages__LastBu'));
    columnNames.set(nameOf<IContentRow>('NextSampleDate'), this.translationService.translate('Nutrients_Ips_Pages__NextSample'));
    columnNames.set(nameOf<IContentRow>('OrganicApplication'), this.translationService.translate('Nutrients_Ips_Pages__OrganicSample'));
    columnNames.set(nameOf<IContentRow>('Description'), this.translationService.translate('Nutrients_Ips_Pages__Note'));
    columnNames.set(nameOf<IContentRow>('GridSize'), this.translationService.translate('Grid_Size'));
    columnNames.set(nameOf<IContentRow>('SampleAmount'), this.translationService.translate('Nutrients_Pages__Samples'));
    columnNames.set(nameOf<IContentRow>('PlannedScan'), this.translationService.translate('Scan_Planned'));
    return columnNames;
  }

  /**
   * Generates the statistic diagrams for last sampling-dates and planned sampling dates
   * @private
   */
  private generateStats(): void {
    const emptyMessage = `${this.translationService.translate('Nutrients__StatisticsTitle')}\n${this.translationService.translate('Base__OrderPlanning')}`;
    let items = this.dynComponent.getSelectedItems() as ISoilSamplingGridData[];
    if (!items || items?.length === 0) {
      items = this.dynComponent?.items as ISoilSamplingGridData[];
    }
    if (!items || items?.length === 0) {
      this.statisticStore.setStatisticData<IChartSet<IBarLineAreaChartData>>(
        [], ApStatsType.GenericBars, '', emptyMessage
      );
      return;
    }
    const allItemsSelected = items.length === this.dynComponent.items.length;
    const chartSets: IChartSet<IBarLineAreaChartData>[] = [];
    // generate each diagram/chart
    chartSets.Add(this.generateLastSamplingStat(items, allItemsSelected));
    chartSets.Add(this.generatePlannedSamplingStat(items, allItemsSelected));
    // calculate min/max of both charts
    for (const chartSet of chartSets) {
      chartSet.axes.minX = 0;
      chartSet.axes.maxX = Math.max(...chartSet.data.data.map(_ => _.value)) * 1.2;
    }
    const title = this.getTitleForStatistic(items);
    this.statisticStore.setStatisticData<IChartSet<IBarLineAreaChartData>>(
      chartSets, ApStatsType.GenericBars, title, emptyMessage
    );
  }

  private getTitleForStatistic(selectedItems: ISoilSamplingGridData[]): string {
    const totalItems = this.dynComponent.items as ISoilSamplingGridData[];
    const dataForTitles = totalItems.map(x => ({
      AreaHa: x.Area,
      Selected: selectedItems.some(z => z.Id === x.Id)
    }));
    return this.statisticService.generateFieldsAreaTitle(dataForTitles);
  }

  /**
   * Generates bar chart configuration for last sampling date per year
   * @param items the selected items
   * @param allItemsSelected indicates if user selected all (or none) items in grid
   * @private
   */
  private generateLastSamplingStat(items: ISoilSamplingGridData[], allItemsSelected: boolean): IChartSet<IBarLineAreaChartData> {
    const chartLastSampling: IChartSet<IBarLineAreaChartData> = {
      axes: {titleX: 'Global__Area'},
      data: {
        data: [], categories: [],
        title: `${this.translationService.translate('Global__Area')} / ${this.translationService.translate('Nutrients_Ips_Pages__LastBu')}`
      },
      noteField: 'note'
    } as IChartSet<IBarLineAreaChartData>;
    // sort items asc by last sampling date:
    items = items.sort((a, b) => this.soilSampleService.compareDates(a.LastSamplingDate, b.LastSamplingDate));
    for (const soilSampleItem of items) {
      // build categories by sampling year
      const buYear = `${soilSampleItem.LastSamplingDate?.getFullYear() ?? '-'}`;
      const barData = chartLastSampling.data?.data.Find(_ => _.category === buYear);
      if (!barData) {
        chartLastSampling.data.data.Add({
          category: buYear,
          value: soilSampleItem.Area,
          color: this.soilSampleService.getStatBarColor(soilSampleItem, soilSampleItem.LastSamplingDate),
        } as IBarLineAreaChartDataValue);
        chartLastSampling.data.categories.AddIfNotExists(buYear);
      } else {
        barData.value = barData.value + soilSampleItem.Area;
      }
    }
    // calculate chart note texts
    // this needs to be done as part of the post-processing,
    // when rounding the note's value, it might lead to inconsistent results
    // e.g. instead of 100% the sum of all % values might be 101% or 99%
    // Here we adjust the values, so it matches the expectations
    this.calculateNoteTexts(chartLastSampling, allItemsSelected);
    return chartLastSampling;
  }

  /**
   * Generates bar chart configuration for planned sampling date per month and year
   * @param selectedItems the selected items
   * @param allItemsSelected indicates if user selected all (or none) items in grid
   * @private
   */
  private generatePlannedSamplingStat(selectedItems: ISoilSamplingGridData[], allItemsSelected: boolean): IChartSet<IBarLineAreaChartData> {
    // Build chart for planned samplings by date
    const chartPlannedSampling: IChartSet<IBarLineAreaChartData> = {
      axes: {titleX: 'Global__Area'},
      data: {
        data: [], categories: [],
        title: `${this.translationService.translate('Global__Area')} / ${this.translationService.translate('Nutrients_Ips_Pages__NextSample')}`
      },
      noteField: 'note'
    } as IChartSet<IBarLineAreaChartData>;
    // sort items by planned sampling date asc
    selectedItems = selectedItems.sort((a, b) => this.soilSampleService.compareDates(a.NextSamplingDate, b.NextSamplingDate));
    for (const soilSampleItem of selectedItems) {
      // build categories by planned sampling month + year
      // in case of samplings with different status for one planned sampling date,
      // a second bar will be displayed with the corresponding color
      const plannedMonthYear = `${soilSampleItem.NextSamplingDate ? moment(soilSampleItem.NextSamplingDate).format('MM/YYYY') : '-'}`;
      const barColor = '#2c3237';
      const barData = chartPlannedSampling.data?.data.Find(_ => _.category === plannedMonthYear && _.color === barColor);
      if (!barData) {
        chartPlannedSampling.data.data.Add({
          category: plannedMonthYear,
          value: soilSampleItem.Area,
          color: barColor,
        } as IBarLineAreaChartDataValue);
        chartPlannedSampling.data.categories.AddIfNotExists(plannedMonthYear);
      } else {
        barData.value = barData.value + soilSampleItem.Area;
      }
    }
    // calculate chart note texts
    // this needs to be done as part of the post-processing,
    // when rounding the note's value, it might lead to inconsistent results
    // e.g. instead of 100% the sum of all % values might be 101% or 99%
    // Here we adjust the values, so it matches the expectations
    this.calculateNoteTexts(chartPlannedSampling, allItemsSelected);
    return chartPlannedSampling;
  }

  /**
   * Generates the bar chart note shown on top of each bar
   * @param chart the generated chart set
   * @param allItemsSelected indicates if user selected all (or none)
   * items in grid => only then an adjustment of percentages is a need.
   * @private
   */
  private calculateNoteTexts(chart: IChartSet<IBarLineAreaChartData>, allItemsSelected: boolean): void {
    if (chart?.data?.data?.length <= 0) {
      return;
    }
    let percentSum = 0;
    let areaSum = 0;
    let biggestValueIdx = 0;
    let biggestArea = 0;
    // we are going to adjust the element with the biggest value
    for (let i = 0; i < chart.data.data.length; i++) {
      const area = this.roundNumericService.roundAsNumber(chart.data.data[i].value, 0);
      const percent = this.roundNumericService.roundAsNumber(area / this._areaTotal * 100, 0);
      if (area > biggestArea) {
        biggestArea = area;
        biggestValueIdx = i;
      }
      percentSum += percent;
      areaSum += area;
      chart.data.data[i].note = this.createNote(percent, area);
    }
    // the adjustment of % only makes sense if all items in the grid are selected.
    // otherwise, the percentage will be raised to 100% even if only 1 row is selected in the grid
    if (!allItemsSelected) {
      return;
    }
    // Adjust the biggest value that total sum matches 100% and the selected area
    chart.data.data[biggestValueIdx].note = this.createNote(
      this.roundNumericService.roundAsNumber(biggestArea / this._areaTotal * 100, 0) + 100 - percentSum,
      biggestArea);
  }

  /**
   * Creates the actual note text containing percentage and area values
   * @param percentage the percentage value of the bar
   * @param area the area value of the bar
   * @private
   */
  private createNote(percentage: number, area: number): string {
    return `${(area < 1 ? '<1' : area)} ${this.translationService.translate('Global__Area')}\n` +
      `(${(percentage < 1 ? '<1' : percentage)} %)`;
  }
}
